import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, watch } from 'vue';
import type { MaterialPreviewProps } from '@/resources/materials/types';

type Emits = {
  (e: 'save', props: MaterialPreviewProps): void;
};
type Props = {
  isCreate?: boolean;
  isDisabled?: boolean;
  isWorking?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'GeneratePreviewDialog',
  props: {
    isCreate: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    isWorking: { type: Boolean, default: false }
  },
  emits: ["save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'save', props: MaterialPreviewProps): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isCreate: boolean, isDisabled: boolean, isWorking: boolean }




const { isWorking } = toRefs(props);

const form = ref();
const valid = ref<boolean>(false);
const dialog = ref<boolean>(false);
const page = ref<number>(1);
// const imageSize = ref<number[]>([794, 1123]); // A4 size with 96dpi

watch(isWorking, (value) => {
  if (!value) {
    dialog.value = false;
  }
});

const onGenerate = () => {
  emit('save', { pageNr: page.value });
};

return { __sfc: true,emit, props, isWorking, form, valid, dialog, page, onGenerate }
}

})